import React, { useState } from 'react'
import { create as ipfsHttpClient } from 'ipfs-http-client'
const ipfs = ipfsHttpClient('https://ipfs.infura.io:5001/api/v0')

const contractURI = (name, description, image, animation_url, external_url, sha256) =>`{
  "name": "${name ? name : ''}",
  "description": "${description ? description : ''}",
  "image": "${image}",
  "animation_url": "${animation_url ? animation_url : ''}",
  "external_url": "${external_url ? external_url : ''}",
  "sha256": "${sha256 ? sha256 : ''}"
}
`

export const Erc721ImageUpload = ({ name, description, animationUrl, externalUrl, setUrl, setPreview, prepareUpload }) => {
    const [image, setImage] = useState({})
    const [contracturi, setContractUri] = useState({})
    const [imagePreview, setImagePreview] = useState('')
    const [loading, setLoading] = useState(false)
    const [uploaded, setUploaded] = useState(false)


    const getJsonFile = (name, description, image, animation_url, external_url, sha256) => {
        const file = new Blob([contractURI(name, description, image, animation_url, external_url, sha256)], { name: "contractURI.json", type: 'application/json' })
        return file
    }

    const createPreview = (e) => {
        if (e.target.value !== '') {
            setImage(e.target.files[0])
            const src = URL.createObjectURL(e.target.files[0])
            setImagePreview(src)
            if (typeof prepareUpload === 'function') {
                prepareUpload(true)
            }
        } else {
            setImagePreview('')
        }
    }

    const uploadFile = async (e) => {
        setLoading(true)
        e.preventDefault()

        try {
            const added = await ipfs.add(image)
            const image_url = `https://ipfs.infura.io/ipfs/${added.path}`
            setImagePreview(image_url)
            setPreview(image_url)
            // set json info
            const jsonblob = getJsonFile(name, description, image_url, '', '', '')
            //setContractUri(jsonblob)
            const added_json = await ipfs.add(jsonblob)
            const url = `https://ipfs.infura.io/ipfs/${added_json.path}`
            setUrl(url)
            setUploaded(true)
        } catch (err) {
            console.log('Error uploading the file : ', err)
        }
        setLoading(false)
    }

    const previewAndUploadButton = () => {
        if (imagePreview !== '') {
            if (!loading) {
                return (
                    <div>
                        {uploaded ? (
                            <h5>
                                ✅{' '}
                                <a
                                    href={imagePreview}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    Image
                                </a>{' '}
                                Uploaded Successfully ✅{' '}
                            </h5>
                        ) : (
                            <div className='mt-3'>
                                <button type='submit' className='inline-flex justify-center py-2 px-4 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-md border border-transparent focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 shadow-sm'>
                                    Upload Image
                                </button>
                                <br />
                                <h5 className='mt-3 mb-3'>
                                    {image.name}{' '}
                                    <span className='bg-green-100 text-green-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'>
                                        {image.size} kb</span>
                                </h5>

                                <img
                                    style={{ height: '269px' }}
                                    className='mb-3'
                                    src={imagePreview}
                                />
                            </div>
                        )}
                    </div>
                )
            } else {
                return (
                    <div className="grid grid-cols-1 gap-y-6 mt-4 sm:grid-cols-3 sm:gap-x-4">
                        <h4>Uploading Image</h4>
                        <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                            <div className="bg-blue-600 h-2.5 rounded-full" style="width: 69%"></div>
                        </div>
                        <h4>Please Wait ...</h4>
                    </div>
                )
            }
        }
    }

    return (
        <div>
            <form onSubmit={uploadFile}>
                <input
                    required
                    type='file'
                    accept='image/*'
                    onChange={(e) => createPreview(e)}
                    className='p-3 text-sm bg-white rounded border-0 focus:outline-none focus:ring shadow transition-all duration-150 ease-linear placeholder:text-blueGray-300 text-blueGray-600'
                />

                {previewAndUploadButton()}
            </form>
        </div>
    )
}
